import { Pipe, PipeTransform } from '@angular/core';
import { LookupModel } from '@eightcap/core';
import { find } from 'lodash';

@Pipe({
    name: 'lookupName'
})
export class LookupNamePipe implements PipeTransform {

    transform(lookupCode: string, lookups: LookupModel[]): string {
        const lookup = find(lookups, (it: LookupModel) => it.code === lookupCode);
        return lookup ? lookup.name : '';
    }

}
